import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#040610] py-8 border-t border-white/5 text-center text-gray-500 text-sm" data-id="element-49">
        <div className="max-w-6xl mx-auto px-4" data-id="element-50">
          <p data-id="element-51">
            © {new Date().getFullYear()} Guía Maestra de Liberación Energética.
            Todos los derechos reservados.
          </p>

          <div className="flex justify-center items-center space-x-4 mt-4" data-id="element-52">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-yellow-400 transition-colors" data-id="element-53">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-54">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-yellow-400 transition-colors" data-id="element-55">
              Términos y Condiciones
            </button>
          </div>

          <p className="mt-4 text-xs opacity-60" data-id="element-56">
            Este producto no sustituye el consejo médico o psicológico
            profesional.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-57">
          {/* Modal Content */}
          <div className="bg-[#0a0e27] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] flex flex-col shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-58">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-6 border-b border-white/10" data-id="element-59">
              <h3 className="text-xl font-bold text-white" data-id="element-60">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors bg-white/5 hover:bg-white/10 rounded-full p-2" aria-label="Cerrar" data-id="element-61">
                <X className="w-5 h-5" data-id="element-62" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto text-gray-300 space-y-6 text-left text-sm leading-relaxed" data-id="element-63">
              {activeModal === 'privacy' ? <>
                  <div data-id="element-64">
                    <h4 className="text-white font-semibold mb-2" data-id="element-65">
                      1. Información que recopilamos
                    </h4>
                    <p data-id="element-66">
                      Recopilamos información personal que usted nos proporciona
                      voluntariamente al registrarse, expresar interés en
                      obtener información sobre nosotros o nuestros productos y
                      servicios. La información personal que recopilamos depende
                      del contexto de sus interacciones con nosotros y el sitio
                      web.
                    </p>
                  </div>
                  <div data-id="element-67">
                    <h4 className="text-white font-semibold mb-2" data-id="element-68">
                      2. Uso de su información
                    </h4>
                    <p data-id="element-69">
                      Utilizamos la información personal recopilada a través de
                      nuestro sitio web para una variedad de fines comerciales
                      descritos a continuación. Procesamos su información
                      personal para estos fines en base a nuestros intereses
                      comerciales legítimos, para celebrar o ejecutar un
                      contrato con usted, con su consentimiento y/o para cumplir
                      con nuestras obligaciones legales.
                    </p>
                  </div>
                  <div data-id="element-70">
                    <h4 className="text-white font-semibold mb-2" data-id="element-71">
                      3. Compartir su información
                    </h4>
                    <p data-id="element-72">
                      Solo compartimos información con su consentimiento, para
                      cumplir con las leyes, para brindarle servicios, para
                      proteger sus derechos o para cumplir con obligaciones
                      comerciales. No vendemos ni alquilamos su información
                      personal a terceros.
                    </p>
                  </div>
                  <div data-id="element-73">
                    <h4 className="text-white font-semibold mb-2" data-id="element-74">
                      4. Conservación de su información
                    </h4>
                    <p data-id="element-75">
                      Solo conservaremos su información personal durante el
                      tiempo que sea necesario para los fines establecidos en
                      esta política de privacidad, a menos que la ley exija o
                      permita un período de retención más largo (como requisitos
                      fiscales, contables u otros requisitos legales).
                    </p>
                  </div>
                  <div data-id="element-76">
                    <h4 className="text-white font-semibold mb-2" data-id="element-77">
                      5. Seguridad de su información
                    </h4>
                    <p data-id="element-78">
                      Hemos implementado medidas de seguridad técnicas y
                      organizativas apropiadas diseñadas para proteger la
                      seguridad de cualquier información personal que
                      procesamos. Sin embargo, a pesar de nuestras salvaguardas
                      y esfuerzos para asegurar su información, ninguna
                      transmisión electrónica a través de Internet o tecnología
                      de almacenamiento de información puede garantizarse como
                      100% segura.
                    </p>
                  </div>
                </> : <>
                  <div data-id="element-79">
                    <h4 className="text-white font-semibold mb-2" data-id="element-80">
                      1. Aceptación de los términos
                    </h4>
                    <p data-id="element-81">
                      Al acceder y utilizar este sitio web, usted acepta estar
                      sujeto a estos Términos y Condiciones de uso, todas las
                      leyes y regulaciones aplicables, y acepta que es
                      responsable del cumplimiento de las leyes locales
                      aplicables. Si no está de acuerdo con alguno de estos
                      términos, tiene prohibido usar o acceder a este sitio.
                    </p>
                  </div>
                  <div data-id="element-82">
                    <h4 className="text-white font-semibold mb-2" data-id="element-83">
                      2. Uso de la licencia
                    </h4>
                    <p data-id="element-84">
                      Se concede permiso para descargar temporalmente una copia
                      de los materiales (información o software) en el sitio web
                      solo para visualización transitoria personal y no
                      comercial. Esta es la concesión de una licencia, no una
                      transferencia de título.
                    </p>
                  </div>
                  <div data-id="element-85">
                    <h4 className="text-white font-semibold mb-2" data-id="element-86">
                      3. Descargo de responsabilidad
                    </h4>
                    <p data-id="element-87">
                      Los materiales en el sitio web se proporcionan "tal cual".
                      No ofrecemos garantías, expresas o implícitas, y por la
                      presente renunciamos y negamos todas las demás garantías,
                      incluidas, entre otras, las garantías implícitas o las
                      condiciones de comerciabilidad, idoneidad para un
                      propósito particular o no infracción de propiedad
                      intelectual u otra violación de derechos.
                    </p>
                  </div>
                  <div data-id="element-88">
                    <h4 className="text-white font-semibold mb-2" data-id="element-89">
                      4. Limitaciones
                    </h4>
                    <p data-id="element-90">
                      En ningún caso nosotros o nuestros proveedores seremos
                      responsables de ningún daño (incluidos, entre otros, daños
                      por pérdida de datos o ganancias, o debido a la
                      interrupción del negocio) que surja del uso o la
                      incapacidad de usar los materiales en el sitio web,
                      incluso si hemos sido notificados verbalmente o por
                      escrito de la posibilidad de tal daño.
                    </p>
                  </div>
                  <div data-id="element-91">
                    <h4 className="text-white font-semibold mb-2" data-id="element-92">
                      5. Modificaciones
                    </h4>
                    <p data-id="element-93">
                      Podemos revisar estos términos de servicio para nuestro
                      sitio web en cualquier momento sin previo aviso. Al
                      utilizar este sitio web, usted acepta estar sujeto a la
                      versión actual de estos Términos y Condiciones de uso.
                    </p>
                  </div>
                </>}
            </div>
          </div>
        </div>}
    </>;
}